import { configureErrorHandler } from '@engage-web/error';

export default defineNuxtPlugin((nuxtApp) => {
  configureErrorHandler(nuxtApp.vueApp, { errorCode: '6440b30122b2ededad8da2588f088180' });
});
